<template>
  <v-container fluid>
    <PageHeader no-padding icon="group_work" :title="currentAnalyteDetail.DisplayName" />
    <AnalyteDetailInformation class="mb-3" :analyteData="currentAnalyteDetail" :analyteGuidelines="analyteGuidelines" />
    <AnalyteAliaManagement class="mb-3" :analyteData="currentAnalyteDetail" />
    <AnalyteGuidelinesManagement class="mb-3" :analyteData="currentAnalyteDetail" @setAnalyteGuidelines="setAnalyteGuidelines" />
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import AnalyteAliaManagement from './AnalyteAliaManagement'
  import AnalyteDetailInformation from './AnalyteDetailInformation'
  import AnalyteUnitManagement from './AnalyteUnitManagement'
  import AnalyteGuidelinesManagement from './AnalyteGuidelinesManagement'
  import AnalyteUtil from '../mixins/AnalyteUtil'
  import PageHeader from '@/components/generic/PageHeader'

  const analyte = createNamespacedHelpers('analyte')
  const unit = createNamespacedHelpers('unit')
  const cofactor = createNamespacedHelpers('cofactor')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    components: {
      PageHeader,
      AnalyteAliaManagement,
      AnalyteDetailInformation,
      AnalyteUnitManagement,
      AnalyteGuidelinesManagement,
    },
    mixins: [AnalyteUtil],
    props: {
      analyteId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        analyteGuidelines: [],
      }
    },
    mounted() {
      this.fetchAnalyteDetail()
      this.getUnitGroup()
      this.getUnitList()
      if (this.currentUserGroup.id || JSON.stringify(this.currentUserGroup) != '{}') {
        this.getCofactorData(this.currentUserGroup.id)
      }
    },
    computed: {
      ...authenticate.mapGetters(['currentUserGroup']),
      ...analyte.mapGetters(['tenantAnalyteList', 'currentAnalyteDetail']),
      selectedAnalyte() {
        let analyte = this.tenantAnalyteList.find(x => x.Id == parseInt(this.analyteId))
        return analyte || {
          AnalyteName: '',
        }
      },
    },
    watch: {
      currentUserGroup() {
        this.getCofactorData(this.currentUserGroup.id)
      },
    },
    methods: {
      ...analyte.mapActions(['getAnalyteDetail']),
      ...unit.mapActions(['getUnitGroup', 'getUnitList']),
      ...cofactor.mapActions(['getCofactorData']),
      fetchAnalyteDetail() {
        let options = {
          data: this.analyteId,
        }
        this.getAnalyteDetail(options)
      },
      setAnalyteGuidelines(v) {
        this.analyteGuidelines = v
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>